//
// SonificationElement.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";
import "../AccessibilityElement";
import "./SonificationTone";

var SonificationElement = createModule("commons::SonificationElement", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getStereoPanValue: [5],
        getAccessibilityElement: [1],
        getTone: [1],
    },
    ,
    ,
]);
export default SonificationElement;
